import { ConnectedChecklists } from "modules/AppointmentDetails/components/Interventions/components/InterventionChecklists/components";
import "modules/AppointmentDetails/components/Interventions/components/InterventionChecklists/components/PendingChecklists/components/SortableList/SortableList.scss";
import "modules/AppointmentDetails/components/Interventions/components/InterventionChecklists/components/PendingChecklists/PendingChecklists.scss";
import "modules/AppointmentDetails/components/Interventions/components/InterventionChecklists/InterventionChecklists.scss";

import type { CarCheck, Intervention } from "models";

type InterventionChecklistPropTypes = {
  connectedChecks: CarCheck[];
  intervention: Intervention;
};

export const InterventionChecklists = ({ connectedChecks, intervention }: InterventionChecklistPropTypes) => (
  <>
    <ConnectedChecklists connectedChecks={connectedChecks} />
    {!!intervention.pending_checklists?.length && (
      <div className="PendingChecklists">
        <div className="sortable-list-container">
          <div className="PendingChecklistsSortableList">
            <ul className="check-container">
              {intervention.pending_checklists.map(pc => (
                <li key={pc.checklist_id}>
                  <div className="input-wrapper">
                    <div className="ordering-number">{pc.ordering}</div>
                    <span> {pc.checklist_name} </span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    )}
  </>
);
